import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import { toBaseUrl, toProjectKey } from '@atlassian/jira-shared-types';
import {
	INITIALIZE_APP_PROPS,
	UPDATE_CATEGORY_SIDEBAR_LABEL,
	type InitializeAppPropsAction,
	type UpdateCategorySidebarLabelAction,
} from '../actions/app';
import type { AppState } from './types';

type Action = InitializeAppPropsAction | UpdateCategorySidebarLabelAction;

export const defaultState: AppState = {
	baseUrl: toBaseUrl(''),
	atlassianAccountId: '',
	cloudId: '',
	fabricPfDirUrl: '',
	locale: defaultLocale,
	userFullname: '',
	portalId: -1,
	projectKey: toProjectKey(''),
	projectId: -1,
	projectName: '',
	projectType: '',
	isAdmin: false,
	isJiraAdmin: false,
	isProjectSimplified: false,
	sidebarCategoryLabel: '',
	activationId: 'ee20ebad-e5a1-42f6-899b-18706f0559e7',
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AppState = defaultState, action: Action): AppState => {
	switch (action.type) {
		case INITIALIZE_APP_PROPS:
			return {
				...state,
				...action.payload,
			};

		case UPDATE_CATEGORY_SIDEBAR_LABEL:
			return {
				...state,
				sidebarCategoryLabel: action.payload,
			};
		default: {
			return state;
		}
	}
};
